import { Game, Player } from "../types/game";
import { Board } from "./mechanics";

const roster = () => ({
  queen: 1,
  ant: 3,
  beetle: 2,
  grasshopper: 3,
  spider: 2,
});

const player = (name: string, id: number): Player => ({
  name,
  id,
  piecesRoster: roster(),
});

export const game = (
  playerNames: string[],
  onlineGameId: string | null,
  localPlayerId: number | null
): Game => {
  const players = playerNames.map((n, i) => player(n, i));
  return {
    onlineGameId,
    localPlayerId,
    winner: null,
    board: new Board([]),
    players: players,
    turnOfPlayer: players[0],
    turn: 0,
    action: {
      placing: null,
      moving: null,
      previewingMoveFor: null,
    },
    movesHistory: [],
  };
};
